import React, { Component } from 'react';
import { TaggisAndDocBrowser } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';
import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class TaggisAndDocBrowserView extends Component {

	render () {
		const {
			buttonLabel,
			content,
			heading,
			href,
			subheading,
		} = this.props.content.landingPage.taggisAndDocBrowser;
		return (
			<TaggisAndDocBrowser
				{...{
					buttonLabel,
					content,
					heading,
					href,
					subheading,
				}}
				className='TaggisAndDocBrowserView'
			/>
		);
	}

}

export default withLanguageContext(TaggisAndDocBrowserView);



// WEBPACK FOOTER //
// ./src/components/views/TaggisAndDocBrowserView/TaggisAndDocBrowserView.js